import { useRouter } from "next/router";

import { getDispensaryUpdates } from "api/requests/getDispensaryUpdates";

import useRequest from "./useRequest";

const useDispensaryUpdates = () => {
  let {
    query: { slug },
  } = useRouter();

  slug = Array.isArray(slug) ? slug[0] : String(slug);

  const [response, { inViewRef }] = useRequest(getDispensaryUpdates, [slug]);

  const updates = response?.data || [];

  return {
    inViewRef,
    updates,
  };
};

export default useDispensaryUpdates;
